import TagsService from './TagsService'

let instance

export default function TagsServiceProvider () {
  if (!instance) {
    instance = new TagsService()
  }

  return instance
}



// WEBPACK FOOTER //
// ./src/api/tags/TagsServiceProvider.js